<template>
    <a class="card-content-link" :href="href">
        <slot></slot>
    </a>
</template>

<script>
    export default {
        name: 'ContentImage',
        props: {
            href: String
        }
    }
</script>

<style lang="scss" scoped>
    .card-content-link {
        display: block;
        outline: none;

        &:not(:last-child) {
            margin-bottom: $card-margin;
        }
    }
</style>